var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingIconGenerate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2357 6.93962C13.6648 5.49023 12.5095 4.33499 11.0602 3.76423C10.8922 3.95518 10.756 4.17485 10.66 4.41492C12.0169 4.90629 13.0936 5.98288 13.585 7.3398C13.825 7.2438 14.0447 7.10764 14.2357 6.93962ZM9.1707 4.12793C9.11407 4.12598 9.05715 4.125 9 4.125C6.30761 4.125 4.125 6.30761 4.125 9C4.125 11.6924 6.30761 13.875 9 13.875C11.6924 13.875 13.875 11.6924 13.875 9C13.875 8.94277 13.874 8.88585 13.8721 8.82907C14.129 8.7486 14.3741 8.6412 14.604 8.51025C14.6179 8.67165 14.625 8.835 14.625 9C14.625 12.1066 12.1066 14.625 9 14.625C5.89339 14.625 3.375 12.1066 3.375 9C3.375 5.89339 5.89339 3.375 9 3.375C9.16492 3.375 9.3282 3.38209 9.48952 3.39601C9.35857 3.62588 9.25117 3.87096 9.1707 4.12793Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.5C13.9926 7.5 15 6.49264 15 5.25C15 4.00736 13.9926 3 12.75 3C11.5074 3 10.5 4.00736 10.5 5.25C10.5 6.49264 11.5074 7.5 12.75 7.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIconGenerate);
export default __webpack_public_path__ + "static/media/pendingIconGenerate.26ac181e7e8d96a995efed4d84057821.svg";
export { ForwardRef as ReactComponent };